import { useEffect } from "react";

interface KeyboardShortcutsProps {
  selectedNodeId: string | null;
  selectedEdgeId: string | null;
  deleteNode: (id: string) => void;
  deleteEdge: (id: string) => void;
  selectedNodes?: any;
  onCopy?: () => void;
  onPaste?: () => void;
}

const isInputFocused = (): boolean => {
  const activeElement = document.activeElement;
  return (
    activeElement?.tagName === "INPUT" ||
    activeElement?.tagName === "TEXTAREA" ||
    activeElement?.getAttribute("contenteditable") === "true"
  );
};

export const useKeyboardShortcuts = ({
  selectedNodeId,
  selectedEdgeId,
  deleteNode,
  deleteEdge,
  selectedNodes = [],
  onCopy,
  onPaste,
}: KeyboardShortcutsProps) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (isInputFocused()) return;

      if (event.key === "Delete" || event.key === "Backspace") {
        event.preventDefault();
        if (selectedNodes.length > 0) {
          selectedNodes.forEach((n: any) => deleteNode(n.id));
        }
      }

      // Copy (Ctrl/Cmd + C)
      if ((event.ctrlKey || event.metaKey) && event.key === "c" && onCopy) {
        event.preventDefault();
        onCopy();
      }

      // Paste (Ctrl/Cmd + V)
      if ((event.ctrlKey || event.metaKey) && event.key === "v" && onPaste) {
        event.preventDefault();
        onPaste();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedNodeId, selectedEdgeId, deleteNode, deleteEdge, onCopy, onPaste]);
};
